import { currentUser } from './stores';
import { get } from 'svelte/store';

const sb_auth_url = () => {
    return[true, 'true'].includes(process['env'].PROD_ENV) ? 'https://auth.shopbox.ai' : 'https://beta-sb-auth-vlwut6qbsq-lz.a.run.app';
}

export const fetchUsers = async () => {
    const res = await fetch(sb_auth_url() + `/api/v1/users?cid=${get(currentUser).clientId}`,
        {
            headers: { Authorization: `Bearer ${get(currentUser).accessToken}` }
        });
    return await res.json();
};

export const fetchCurrentUser = async () => {
    const res = await fetch(sb_auth_url() + `/api/v1/users/me?tokens=true&cid=${get(currentUser).clientId}`,
        {
            headers: { Authorization: `Bearer ${get(currentUser).accessToken}` }
        });
    return await res.json();
}

export const fecthUserTokens = async () => {
    let currentUser = await fetchCurrentUser()
    return currentUser.tokens
}

export const updateUserPermissions = async (permissions, user_id) => {
    let params = []
    for (const permission in permissions) {
        params.push(`${permission}=${permissions[permission]}`)
    }
    let formatedParams = params.join('&')

    if (user_id && formatedParams) {
        formatedParams += `&user_id=${user_id}`
    }
    formatedParams += `&cid=${get(currentUser).clientId}`

    const res = await fetch(sb_auth_url() + `/api/v1/users/permissions?${formatedParams}`, {
        method: 'PATCH',
        headers: { Authorization: `Bearer ${get(currentUser).accessToken}` },
    });
    return res.ok && res.status == 202
}

export const deleteUser = async (user_id) => {
    const res = await fetch(sb_auth_url() + `/api/v1/users/${user_id}?cid=${get(currentUser).clientId}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${get(currentUser).accessToken}` },
    });
    return res.ok && res.status == 204
}

export const deleteToken = async (token_id) => {
    const res = await fetch(sb_auth_url() + `/api/v1/tokens/${token_id}?cid=${get(currentUser).clientId}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${get(currentUser).accessToken}` },
    });
    return res.ok && res.status == 204
}

export const inviteNewUser = async (email) => {
    const res = await fetch(sb_auth_url() + `/api/v1/invite?cid=${get(currentUser).clientId}`, {
        method: 'POST',
        body: JSON.stringify(email),
        headers: {
            Authorization: `Bearer ${get(currentUser).accessToken}`,
            'Content-Type': 'application/json'
        },
    });

    return await res.json()
}

export const createToken = async (tokenName, website = '') => {
    let query_params = `?cid=${get(currentUser).clientId}`
    if (website) {
        query_params += `&website=${website}`
    }
    const res = await fetch(sb_auth_url() + `/api/v1/tokens${query_params}`, {
        method: 'POST',
        body: JSON.stringify({ name: tokenName }),
        headers: {
            Authorization: `Bearer ${get(currentUser).accessToken}`,
            'Content-Type': 'application/json'
        },
    });
    return res.ok && res.status == 200
}